import { useEffect, useRef, useState } from 'react';
import { type UpdateWatcher, watchForUpdates } from '@/lib/serviceWorkerUpdate';

export function useServiceWorkerUpdate(): {
  ready: boolean;
  error: string | undefined;
  apply: () => void;
} {
  const [ready, setReady] = useState(false);
  const [error, setError] = useState<string | undefined>(undefined);
  const watcher = useRef<UpdateWatcher | null>(null);

  useEffect(() => {
    const container = navigator.serviceWorker;
    if (!container) return;
    let stopped = false;
    watchForUpdates(() => setReady(true), container).then(
      (found) => {
        // StrictMode's second pass tears this one down before it is stored.
        if (stopped) found.stop();
        else watcher.current = found;
      },
      (err) => setError(err instanceof Error ? err.message : String(err)),
    );
    return () => {
      stopped = true;
      watcher.current?.stop();
      watcher.current = null;
    };
  }, []);

  return { ready, error, apply: () => watcher.current?.apply() };
}
